var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavouriteheart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-26.69 -26.69 434.63 434.63",
    xmlSpace: "preserve",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.0038124700000000005,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 2.287482
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6b696d"
    },
    d: "M191.847,360.957c-4.648,0-9.076-1.784-12.447-5.024c-0.245-0.233-29.256-28.289-146.439-145.472 l-0.817-0.817c-1.205-1.193-1.796-1.88-2.387-2.572C10.621,186.384,0,159.48,0,131.483C0,70.173,49.883,20.29,111.193,20.29 c30.091,0,58.672,12.113,79.425,33.444c20.759-21.332,49.346-33.444,79.437-33.444c61.31,0,111.193,49.883,111.193,111.193 c0,30.723-12.31,59.305-34.673,80.535c-0.328,0.382-0.627,0.686-0.847,0.901C227.6,331.045,205.195,355.002,204.98,355.229 c-3.288,3.514-7.9,5.597-12.674,5.716L191.847,360.957z M111.199,32.23c-54.734,0-99.259,44.525-99.259,99.259 c0,24.983,9.499,49.012,26.744,67.664c0.585,0.674,1.002,1.164,1.886,2.041l0.835,0.835 C158.552,319.177,187.413,347.084,187.67,347.334c1.128,1.086,2.596,1.683,4.135,1.695l0.251-0.006 c1.557-0.042,3.109-0.74,4.207-1.915c0.173-0.191,22.764-24.339,141.009-142.584l0.859-0.925 c20.114-18.969,31.195-44.578,31.195-72.104c0-54.734-44.525-99.259-99.259-99.259c-28.862,0-56.166,12.477-74.914,34.238 l-4.523,5.245l-4.523-5.251C167.365,44.707,140.066,32.23,111.199,32.23z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteheart);
export default __webpack_public_path__ + "static/media/favouriteheart.7e68ce5e5a6081e443ae7e344be15a65.svg";
export { ForwardRef as ReactComponent };